<template>
    <div class="layout-app">
			<!-- 路由出口 -->
			<div class="layout-main">
				<router-view></router-view>
			</div>
    </div>
</template>

<script>

    export default {
        components:{
            
        }
    }
</script>

<style lang="less" scoped>
.layout-app{
    width: 100%;
    height: 100%;
    // display: flex;
	background-color: f8f8f8;
    // .layout-left{
		// width: 100%;
		// height: 660px;
    // }
    // .layout-right{
    //     flex: 1;
    //     display: flex;
    //     flex-direction: column;
    //     .layout-main{
    //         flex: 1;
    //         // overflow-y: scroll;//滚动条
            
    //     }
    // }
}
</style>